/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Print_TitleInputs */

const zh_print_title = /** @type {(inputs: Print_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打印`)
};

const en_print_title = /** @type {(inputs: Print_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Print`)
};

const es_print_title = /** @type {(inputs: Print_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imprimir`)
};

/**
* | output |
* | --- |
* | "Print" |
*
* @param {Print_TitleInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const print_title = /** @type {((inputs?: Print_TitleInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Print_TitleInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_print_title(inputs)
	if (locale === "en") return en_print_title(inputs)
	return es_print_title(inputs)
});